$(function () {
    if ($("#rd_news_1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd_news_1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd_news_1").addClass("ani_do").removeClass("op0");
            },
        });
    }
});
